import React from 'react';
import {
  Box,
  Card,
  FormControl,
  FormHelperText,
  IconButton,
  MenuItem,
  Select,
  styled,
  TextField,
  useTheme,
} from '@mui/material';
import Delete from '@mui/icons-material/Delete';
import Grid2 from '@thirdparty-framework/mui/material/Grid';
import ReadMoreText from '@ui-framework/components/UI/ReadMoreText';
import { Controller, useWatch } from 'react-hook-form';
import {
  getFileExtension,
  getFormattedFileSize,
  useMasterData,
} from '@ui-framework/index';
import FileIcon from './FileIcon';

const FileCard = styled(Card)({
  borderRadius: '15px',
  padding: '10px',
});

function FileUpload({ file, onRemove, control, fieldName, index }) {
  const theme = useTheme();
  const masterData = useMasterData();

  const attachmentType = useWatch({
    control,
    name: `${fieldName}.${index}.attachmentType`,
  });

  return (
    <Box sx={{ width: '100%', my: 0.5 }}>
      <FileCard
        variant="outlined"
        sx={{ border: `1px solid ${theme.palette.primary.main}` }}>
        <Grid2 container alignItems="center" spacing={1}>
          <Grid2>
            <FileIcon color="primary" ext={getFileExtension(file.name)} />
          </Grid2>
          <Grid2 xs={3}>
            <ReadMoreText maxChars={50}>{file.name}</ReadMoreText>
            <Box>{getFormattedFileSize(file?.size)}</Box>
          </Grid2>
          <Grid2 xs={3}>
            <Controller
              control={control}
              name={`${fieldName}.${index}.attachmentType`}
              render={({ field, fieldState }) => (
                <Box>
                  <FormControl fullWidth error={!!fieldState.error}>
                    <Select
                      displayEmpty
                      placeholder="Please select Attachment Type"
                      size="small"
                      {...field}>
                      {[
                        { label: 'Please select Attachment Type', value: '' },
                        ...(masterData?.attachmentTypes ?? []),
                      ].map(aType => (
                        <MenuItem key={aType.value} value={aType.value}>
                          {aType.label}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                  <FormHelperText error={!!fieldState.error}>
                    {fieldState.error?.message}
                  </FormHelperText>
                </Box>
              )}
            />
          </Grid2>
          <Grid2 xs>
            {attachmentType === 'OTHER' && (
              <Controller
                control={control}
                name={`${fieldName}.${index}.description`}
                render={({ field, fieldState }) => (
                  <Box>
                    <FormControl fullWidth>
                      <TextField
                        placeholder="Add Description"
                        size="small"
                        {...field}
                      />
                    </FormControl>
                    <FormHelperText error={!!fieldState.error}>
                      {fieldState.error?.message}
                    </FormHelperText>
                  </Box>
                )}
              />
            )}
          </Grid2>
          <Grid2 xs={2}>
            <IconButton
              onClick={() => {
                onRemove();
              }}
              sx={{ background: theme.palette.secondary.light }}>
              <Delete color="error" />
            </IconButton>
          </Grid2>
        </Grid2>
      </FileCard>
    </Box>
  );
}

export default FileUpload;
